module.exports = __webpack_public_path__ + "static/media/restaurant2.ea9042a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Restaurant/images/restaurant2.jpg
// module id = 375
// module chunks = 0